import {useState} from 'react';

import type {HistoryCardProps} from 'domain/usecases';

import type {HistoryRow} from '../components/HistoryTable/types';
import {usePaymentsHistory} from './usePaymentsHistory';

const MONTH_MAP: Record<string, string> = {
	JANEIRO: 'Jan',
	FEVEREIRO: 'Fev',
	MARÇO: 'Mar',
	ABRIL: 'Abr',
	MAIO: 'Mai',
	JUNHO: 'Jun',
	JULHO: 'Jul',
	AGOSTO: 'Ago',
	SETEMBRO: 'Set',
	OUTUBRO: 'Out',
	NOVEMBRO: 'Nov',
	DEZEMBRO: 'Dez',
};

function parseVlObrigacao(value: string): number {
	return parseFloat(value.replace(/\./g, '').replace(',', '.'));
}

function safeParseVlObrigacao(value: string | null | undefined): number {
	if (typeof value !== 'string' || !value) return 0;
	const parsed = parseVlObrigacao(value);
	return Number.isFinite(parsed) ? parsed : 0;
}

function mapHistoryRows(data: HistoryCardProps[], year: string): HistoryRow[] {
	return data.map((item, index) => ({
		id: String(index + 1),
		valor: item.vlPagamento ?? safeParseVlObrigacao(item.vlObrigacao),
		referencia: `${MONTH_MAP[item.mes] ?? item.mes}/${year}`,
		pagamento: item.dtPagamento,
		vencimento: item.dtVencimento,
		dsTipoPagamento: item.dsTipoPagamento,
		dsCartaoBandeira: item.dsCartaoBandeira,
		vlPagamento: item.vlPagamento,
		vlSemTaxa: item.vlSemTaxa,
		vlTaxa: item.vlTaxa,
	}));
}

export const useHistoryPage = () => {
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [selectedRow, setSelectedRow] = useState<HistoryRow | null>(null);

	const {
		paymentsHistoryData,
		paymentsLoading: isLoading,
		paymentsHasError: isError,
		handleTryAgain,
		SEARCH_PARAMS,
	} = usePaymentsHistory();

	const historyRows = paymentsHistoryData
		? mapHistoryRows(paymentsHistoryData, SEARCH_PARAMS.year)
		: [];

	const handleViewDetails = (row: HistoryRow) => {
		setSelectedRow(row);
		setDrawerOpen(true);
	};

	const handleCloseDrawer = () => {
		setDrawerOpen(false);
		setSelectedRow(null);
	};

	return {
		drawerOpen,
		selectedRow,
		historyRows,
		isLoading,
		isError,
		handleViewDetails,
		handleCloseDrawer,
		handleTryAgain,
	};
};
